export default function returnError(stage, signInType) {
    const errorMap = {
        EMAIL: "verify your email address.",
        PHONE: "verify your mobile phone number.",
        OTP: "sign you in.",
        VERIFY: {
            EMAIL:"verify your email address.",
            PHONE:"verify your mobile phone number."
        } 
    }
    const error = stage !== "VERIFY" ? errorMap[stage] : errorMap.VERIFY?.[signInType];
    return (
        <span>We're unable to {error}</span>
    );
}